import React, {useEffect, useState} from 'react'
import logo from "../assetes/logo.png";
import Info from './Info';
import Pdfs from './Pdfs';
import Hochladen from './Hochladen';
import Fotos from './Fotos.jsx';
import AdminNotizen from './AdminNotizen';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAccidentById, getAllAccident, updateAccident } from '../redux/apiCalls/accidentApiCall.js';
import Mal from './10Mal.jsx';
import Daten from './Daten.jsx';
import Schaden from './Schaden.jsx';
import Altschaden from './Altschaden.jsx';
function OpenEye() {
  const role = sessionStorage.getItem('role');
  const [activeComponent, setActiveComponent] = useState("Info");
  const renderActiveComponent = () => {
    switch (activeComponent) {
      case "Info":
        return <Info />;
      case "Pdfs":
        return <Pdfs />;
      case "Hochladen":
        return <Hochladen />;
      case "10Mal":
        return <Mal />;
      case "Daten": 
        return <Daten />;
      case "Schaden": 
        return <Schaden />;
      case "Altschaden":
        return <Altschaden />;
      case "AdminNotizen":
        return <AdminNotizen />;
      // case "Fotos":
      //   return <Fotos />;
      default:
        return null;
    }
  };
  const { id } = useParams();
  const dispatch = useDispatch();
  const { lastAccident, getLoading } = useSelector((state) => state.accident);
  const [formData, setFormData] = useState(lastAccident || {});

  useEffect(() => {
    dispatch(getAccidentById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (lastAccident) {
      setFormData(lastAccident);
    }
  }, [lastAccident]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(6);
  const handlePhaseChange = async (id, newPhase) => {
    try {
      // تحديث المرحلة على الخادم
      await dispatch(updateAccident(id, { phase: newPhase }));
      
      // إعادة تحميل البيانات لتحديث الواجهة
      dispatch(getAllAccident(currentPage, perPage));
    } catch (error) {
      console.error("Error updating phase:", error);
    }
  };


  if (getLoading) {
    return <div>Loading...</div>;
  }
  const user = JSON.parse(sessionStorage.getItem("user"));
  
    if (!lastAccident) {
      return <div>Loading...</div>;
    }
    return (
      <div className='flex flex-col w-full h-screen element overflow-y-auto'>
        <div className='flex flex-col w-full px-2 sm:px-4'>
          <div className="flex flex-col sm:flex-row justify-between items-center w-full pt-2 sm:pt-4">
            <div className="order-2 sm:order-1">
              <h1 className="font-montserrat text-lg sm:text-2xl font-bold flex items-center">
                <span className="mr-2">{formData?.kundenName}</span> 
                <span className="hidden sm:inline">Auftrag Übersicht</span>
                <span className="sm:hidden">Übersicht</span>
              </h1>
            </div>
            <div className="flex items-center order-1 sm:order-2 mb-2 sm:mb-0">
              <div className=" mr-2 text-center md:text-right">
                <h4 className="text-xs sm:text-sm">{user.username}</h4>
                <p className="text-[10px] sm:text-xs text-gray-500">{user.role}</p>
              </div>
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-gray-700 flex items-center justify-center">
                <img src={logo} alt='img-pro' className="w-3/4 h-3/4" />
              </div>
            </div>
          </div>
          <div className="border-b border-black w-full mt-2 sm:mt-4"></div>
        </div>
  
        <div className="pt-4 px-2 sm:px-4">
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <thead className="bg-gradient-to-b from-[#3a3a3a] to-[#1a1a1a] text-white">
                <tr className="flex flex-col sm:table-row">
                  {/* Mobile Header */}
                  <th className="sm:hidden px-2 py-1 border-b border-gray-400">
                  <select 
  className="w-full bg-[#3a3a3a] text-white text-sm rounded-lg border border-white"
  onChange={(e) => setActiveComponent(e.target.value)}
  value={activeComponent}
>
  <option className="bg-[#3a3a3a] border-b border-white" value="Info">Info</option>
  {role === "admin" && <option className="bg-[#3a3a3a] border-b border-white" value="Pdfs">PDFs</option>}
  {role === "admin" && <option className="bg-[#3a3a3a] border-b border-white" value="AdminNotizen">Admin Notizen</option>}
  <option className="bg-[#3a3a3a] border-b border-white" value="10Mal">10mal</option>
  <option className="bg-[#3a3a3a] border-b border-white" value="Daten">Daten</option>
  <option className="bg-[#3a3a3a] border-b border-white" value="Schaden">Schaden</option>
  <option className="bg-[#3a3a3a] border-b border-white" value="Altschaden">Altschaden</option>
  <option className="bg-[#3a3a3a]" value="Hochladen">Hochladen</option>
</select>


                  </th>
                  
                  {/* Desktop Headers */}
                  {["Info", "Pdfs", "AdminNotizen", "10Mal", "Daten", "Schaden", "Altschaden", "Hochladen"].map((tab) => (
                    <th 
                      key={tab}
                      className="hidden sm:table-cell px-2 py-1 sm:px-4 sm:py-2 text-left border-b border-gray-400 cursor-pointer text-sm sm:text-base"
                      onClick={() => role !== "admin" && tab.includes("Admin") ? null : setActiveComponent(tab)}
                    >
                      {tab}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          
          <div className="mt-4 pb-16 sm:pb-4">{renderActiveComponent()}</div>
        </div>
      </div>
    );
  
}

export default OpenEye
